<template>
  <div>
    <el-button
      v-if="$hasPerm('tenant:partner_gift_coin:donate')"
      size="mini"
      type="primary"
      @click="open"
      >赠币</el-button
    >
    <el-dialog
      title="赠币"
      :visible.sync="centerDialogVisible"
      width="50%"
      center
      @close="clear"
      :show-close="false"
    >
      <div class="main" v-loading="loading">
        <el-card class="box-card">
          <div class="balance-row">
            <span class="balance-label">余额:</span>
            <el-select
              v-model="balanceCoin"
              size="mini"
              style="width: 120px"
              @change="loadPublicBalance"
            >
              <el-option
                v-for="c in coinOptions"
                :key="c"
                :label="c"
                :value="c"
              />
            </el-select>
            <span class="balance-value">{{ publicBalance | fixD(8) }}</span>
          </div>
          <div class="toolbar">
            <el-button icon="el-icon-plus" type="primary" size="mini" @click="addDomain"
              >添加用户</el-button
            >
          </div>
          <div class="content">
            <div class="up">
              <div class="item up-item">用户uid</div>
              <div class="item up-item">币种</div>
              <div class="item up-item">数量</div>
              <el-button style="opacity: 0" size="mini">删除</el-button>
            </div>
            <div
              class="down"
              v-for="domain in dynamicValidateForm.domains"
              :key="domain.key"
            >
              <div class="item">
                <el-input
                  class="ipt"
                  size="mini"
                  v-model="domain.userId"
                  placeholder="请输入用户uid"
                />
              </div>
              <div class="item">
                <el-select v-model="domain.coin" size="mini" class="ipt" placeholder="币种">
                  <el-option v-for="c in coinOptions" :key="c" :label="c" :value="c" />
                </el-select>
              </div>
              <div class="item">
                <el-input
                  class="ipt"
                  size="mini"
                  v-model="domain.amount"
                  placeholder="请输入赠币数量"
                />
              </div>
              <el-button size="mini" @click.prevent="removeDomain(domain)">删除</el-button>
            </div>
          </div>
          <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="mini">
            <el-form-item label="谷歌验证码" prop="googleCode">
              <el-input v-model.trim="form.googleCode" placeholder="赠送前必填" />
            </el-form-item>
          </el-form>
          <div class="btn">
            <el-button size="mini" type="primary" :loading="submitting" @click="add"
              >赠送</el-button
            >
            <el-button size="mini" @click="clear">取消</el-button>
          </div>
        </el-card>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import api from "../../api";

const defaultDomain = () => ({
  userId: "",
  coin: "USDT",
  amount: "",
  key: Date.now(),
});

export default {
  props: ["userId"],
  data() {
    return {
      centerDialogVisible: false,
      loading: false,
      submitting: false,
      balanceCoin: "USDT",
      publicBalance: 0,
      coinOptions: [],
      dynamicValidateForm: {
        domains: [defaultDomain()],
      },
      form: { googleCode: "" },
      rules: {
        googleCode: [{ required: true, message: "请填写谷歌验证码", trigger: "blur" }],
      },
    };
  },
  methods: {
    ...mapActions("giftCoin", ["list"]),
    async open() {
      this.centerDialogVisible = true;
      await this.loadCoins();
      await this.loadPublicBalance();
    },
    async loadCoins() {
      const res = await api.supportedCoins();
      if (res.code === 0 && Array.isArray(res.data)) {
        this.coinOptions = res.data;
        if (!this.coinOptions.includes("USDT") && this.coinOptions.length) {
          this.balanceCoin = this.coinOptions[0];
        }
      }
    },
    async loadPublicBalance() {
      const res = await api.publicBalance(this.balanceCoin);
      if (res.code === 0) {
        this.publicBalance = res.data || 0;
      }
    },
    addDomain() {
      this.dynamicValidateForm.domains.push(defaultDomain());
    },
    removeDomain(item) {
      const index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1 && this.dynamicValidateForm.domains.length > 1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    buildLines() {
      return this.dynamicValidateForm.domains
        .map((e) => ({
          userId: e.userId ? Number(e.userId) : null,
          coin: (e.coin || "").trim(),
          amount: e.amount === "" || e.amount == null ? null : Number(e.amount),
        }))
        .filter((row) => row.userId != null && row.coin && row.amount != null);
    },
    validateRows() {
      for (const row of this.dynamicValidateForm.domains) {
        const hasU = !!row.userId;
        const hasC = !!row.coin;
        const hasA = row.amount !== "" && row.amount != null;
        if (hasU !== hasC || hasU !== hasA) {
          return "同一行用户、币种、数量须同时填写或同时为空";
        }
        if (hasA && Number(row.amount) <= 0) {
          return "数量须大于0";
        }
      }
      const lines = this.buildLines();
      if (!lines.length) {
        return "请至少填写一行完整赠币明细";
      }
      return "";
    },
    add() {
      const rowErr = this.validateRows();
      if (rowErr) {
        return this.$message.warning(rowErr);
      }
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        this.submitting = true;
        try {
          const res = await api.sendCoin({
            arr: this.buildLines(),
            googleCode: this.form.googleCode,
          });
          if (res.code !== 0) {
            this.$message.error(res.msg || "赠送失败");
            return;
          }
          const data = res.data || {};
          const lines = data.lines || [];
          const failed = lines.filter((l) => !l.success);
          if (data.allSuccess) {
            this.$message.success("全部赠送成功");
            this.clear();
            this.list({ userId: this.userId, page: 1, size: 10 });
          } else if (failed.length) {
            const msg = failed.map((l) => `${l.userId}/${l.coin}: ${l.message}`).join("; ");
            this.$message.warning(`部分失败: ${msg}`);
            this.list({ userId: this.userId, page: 1, size: 10 });
          } else {
            this.$message.success("赠送完成");
            this.clear();
            this.list({ userId: this.userId, page: 1, size: 10 });
          }
        } finally {
          this.submitting = false;
        }
      });
    },
    clear() {
      this.centerDialogVisible = false;
      this.form.googleCode = "";
      this.dynamicValidateForm = { domains: [defaultDomain()] };
      this.balanceCoin = "USDT";
    },
  },
};
</script>

<style lang="less" scoped>
.balance-row {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  .balance-label {
    margin-right: 8px;
  }
  .balance-value {
    margin-left: 12px;
    font-weight: 600;
  }
}
.toolbar {
  margin-bottom: 8px;
}
.box-card {
  .content {
    padding: 12px 0;
    .up,
    .down {
      display: flex;
      align-items: center;
      border: 1px solid #f5f6f7;
    }
    .item {
      flex: 1;
      padding: 8px;
      .ipt {
        width: 100%;
      }
    }
  }
}
.btn {
  display: flex;
  justify-content: center;
  gap: 16px;
  margin-top: 12px;
}
</style>
